import ServicesStatusBoardDispatcher from "../dispatcher/ServicesStatusBoardDispatcher"
import ServicesStatusBoardConstants from "../constants/ServicesStatusBoardConstants"

var ServicesStatusBoardActions = {

    init: function (opts) {
        ServicesStatusBoardDispatcher.dispatch({
            action: ServicesStatusBoardConstants.INIT,
            opts: opts
        });
    },

    gotoDate: function (date) {
        ServicesStatusBoardDispatcher.dispatch({
            action: ServicesStatusBoardConstants.GOTO_DATE,
            date: date
        });
    },
};

export default ServicesStatusBoardActions